module.exports = __webpack_public_path__ + "static/img/bear2.3fa3e636.png";